module.exports = __webpack_public_path__ + "img/dedicated-right-4x.923153f8.png";